import type { ProfileConfig } from '@/types/edit/ProfileConfig.ts';

export const DefaultProfileConfigs: Record<ProfileConfig['id'], ProfileConfig> = {
    ['6f18d96e-8bd5-46c7-928f-923b1f32ca35']: {
        id: '6f18d96e-8bd5-46c7-928f-923b1f32ca35',
        name: 'Leetcode',
        stepIds: ['30ce2bbf-dedf-4b3e-a4c0-b85602ce825f', '807e8d2d-e065-4815-9547-ee455e5194f7'],
        promptIds: [
            '6e7a389a-696e-4ad3-9f38-2a49e61bc43d',
            'bcdd0a89-db5a-4ef2-8e2b-2dff88b9272f',
            '89974ad1-22aa-417d-a18c-cb120b6931a2',
        ],
        editable: false,
    },
};
